module.exports = __webpack_public_path__ + "static/media/mob22.2d8001cf.jpg";